import { useCallback, useEffect, useState } from "react";
import { API, get } from "../../config";

export const useStateList = () => {
  const [stateList, setStateList] = useState([]);
  const [stateLoading, setStateLoading] = useState(false);
  const init = useCallback(async () => {
    try {
      setStateLoading(true);
      const { data } = await get(API.GET_STATE_LIST);
      setStateLoading(false);
      setStateList(data.data);
    } catch (e) {
      setStateList([]);
      setStateLoading(false);
    }
  }, []);

  useEffect(() => {
    init();
  }, [init]);

  return {
    stateList,
    stateLoading,
  };
};

export const useAllOrganizationTypes = ({amlCTFType = false}) => {
  const [allOrganizationType, setAllOrganizationType] = useState([]);
  const [allOrganizationTypeLoading, setAllOrganizationTypeLoading] =
    useState(false);
  const init = useCallback(async () => {
    try {
      setAllOrganizationTypeLoading(true);
      const { data } = await get(
        `${API.GET_ORGANIZATION_TYPES}?aml_ctf_type=${amlCTFType ? 1 : 0}`
      );
      setAllOrganizationTypeLoading(false);

      const accountList =
        data?.data && data?.data?.length > 0
          ? data?.data?.map((item) => {
              const list = {
                label: item?.name,
                value: item?.id,
                rest: item,
              };
              return list;
            })
          : [];
      setAllOrganizationType(accountList);
    } catch (e) {
      setAllOrganizationType([]);
      setAllOrganizationTypeLoading(false);
    }
  }, [amlCTFType]);

  useEffect(() => {
    init();
  }, [init]);
  return {
    allOrganizationType,
    allOrganizationTypeLoading,
  };
};

export const useAllPaymentMethodList = () => {
  const [allPaymentMethodList, setAllPaymentMethodList] = useState([]);
  const [allPaymentMethodLoading, setAllPaymentMethodLoading] = useState(false);
  const init = useCallback(async () => {
    try {
      setAllPaymentMethodLoading(true);
      const { data } = await get(`${API.GET_PAYMENT_METHOD_LIST}`);
      setAllPaymentMethodLoading(false);
      const accountList =
        data?.data?.paymentMethods && data?.data?.paymentMethods?.length > 0
          ? data?.data?.paymentMethods?.map((item) => {
              const list = {
                label: item?.type,
                value: item?.id,
                rest: item,
              };
              return list;
            })
          : [];
      setAllPaymentMethodList(accountList);
    } catch (e) {
      setAllPaymentMethodList([]);
      setAllPaymentMethodLoading(false);
    }
  }, []);

  useEffect(() => {
    init();
  }, [init]);
  return {
    allPaymentMethodList,
    allPaymentMethodLoading,
  };
};

export const useAllModules = () => {
  const [allModule, setAllModule] = useState([]);
  const [allModuleLoading, setAllModuleLoading] = useState(false);
  const init = useCallback(async () => {
    try {
      setAllModuleLoading(true);
      const { data } = await get(
        `${API.GET_MODULE_LIST}?limit=${-1}&page=${1}&type=naming`
      );
      setAllModuleLoading(false);

      const accountList =
        data?.data?.data && data?.data?.data?.length > 0
          ? data?.data?.data?.map((item) => {
              const list = {
                label:
                  item?.name === "Contacts"
                    ? "Customer"
                    : item?.name?.slice(0, -1),
                value: item?.id,
                rest: item,
              };
              return list;
            })
          : [];
      setAllModule(accountList);
    } catch (e) {
      setAllModule([]);
      setAllModuleLoading(false);
    }
  }, []);

  useEffect(() => {
    init();
  }, [init]);
  return {
    allModule,
    allModuleLoading,
  };
};
